export default {"forgotPasswordForm":"kL3xJ","helperText":"-wwpE","buttonSection":"sh0kF"};